"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceInput = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const theme_1 = require("../theme");
const distance_input_style_1 = require("./distance.input.style");
const input_1 = require("./input");
const unit_1 = require("./unit");
(0, theme_1.addStyles)(distance_input_style_1.Style);
exports.DistanceInput = {
    view(state, unit = services_1.Services.UserSettings.units) {
        let children;
        if (unit === core_shared_1.IkeUnit.METER) {
            children = exports.DistanceInput.viewMetric(state.meters);
        }
        else {
            children = exports.DistanceInput.viewImperial(state.feet, state.inch);
        }
        return (0, mithril_1.m)('div', { className: distance_input_style_1.CSS.container }, children);
    },
    viewMetric(state) {
        return [
            input_1.Input.view(state),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_METER)
        ];
    },
    viewImperial(feetState, inchState) {
        return [
            input_1.Input.view(feetState),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_FEET),
            input_1.Input.view(inchState),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_INCH)
        ];
    }
};
//# sourceMappingURL=distance.input.js.map